import React from 'react';
import { WebCamSwitch, UserVideo } from 'components';
import { MappedExamSessionReadyStatuses, ExamSessionReadyStatuses } from 'components/enums';
import { VideoType } from '_helpers';
import messageIcon from 'components/assets/svg/message_icon.svg';
import alertIcon from 'components/assets/svg/alert_icon.svg';
import styles from './OnlineVideo.module.scss';
import cn from 'classnames';

const OnlineVideo: React.FC<IProps> = ({
    applicantFullName,
    applicantId,
    className,
    videoStream,
    processing,
    onSwitch,
    examSessionReadyStatus,
    withoutFullScreen,
    ...props
}) => {
    const fullNameArray = applicantFullName.split(' ');
    const lastName = fullNameArray[0];
    const firstName = fullNameArray[1][0];
    const middleName = fullNameArray[2][0];

    const handleSwitchVideoType = React.useCallback(() => {
        const nextType = props.videoType === VideoType.Cam ? VideoType.Screen : VideoType.Cam;

        if (onSwitch) {
            onSwitch(nextType, applicantId);
        }
    }, [applicantId, props.videoType]);

    const handleClickPreview = React.useCallback(() => {
        if (props.onPreviewClick) {
            props.onPreviewClick(applicantId);
        }
    }, [applicantId]);

    return (
        <div className={cn(styles.videoContainer, className)} onClick={handleClickPreview}>
            <WebCamSwitch
              value={props.videoType === VideoType.Cam}
              name="videoType"
              onClick={handleSwitchVideoType}
              webCam={props.videoType === VideoType.Cam}
              containerClassName={styles.switch}
            />

            <UserVideo
              processing={processing}
              className={styles.video}
              videoStream={videoStream}
              onClick={handleClickPreview}
              connectionLost={props.haveStream === false}
              withoutFullScreen={withoutFullScreen}
              autoPlay
              muted
            />

            <div className={styles.infoContainer}>
                <span className={styles.title}>{lastName} {firstName}.{middleName}.</span>
                <span className={styles.examPart}>{examSessionReadyStatus ? MappedExamSessionReadyStatuses[examSessionReadyStatus].text : 'Ожидает начала экзамена'}</span>
            </div>

            <div className={styles.iconsContainer}>
                {props.haveNewMessages && (
                    <img
                      className={cn(styles.icon)}
                      src={messageIcon}
                      onClick={handleClickPreview}
                      alt="messageIcon"
                    />
                )}
                {props.haveNewAlerts && (
                    <img
                      className={cn(styles.icon)}
                      src={alertIcon}
                      onClick={handleClickPreview}
                      alt="alertIcon"
                    />
                )}
            </div>
        </div>
    );
};

export default OnlineVideo;

interface IProps {
    applicantFullName: string;
    applicantId: string;
    examSessionReadyStatus: ExamSessionReadyStatuses | undefined;
    className?: string;
    videoStream?: MediaStream;
    videoType?: VideoType;
    processing?: boolean;
    haveNewMessages?: boolean;
    haveNewAlerts?: boolean;
    haveStream?: boolean;
    withoutFullScreen?: boolean;
    onSwitch?: (videoType: VideoType, applicantId: string) => void;
    onPreviewClick?: (applicationId: string) => void;
}
